import friends from "./friends";
import sizeRecommendation from "./sizeRecommendation";
import sizeAdvisor from "./sizeAdvisor";

export default { ...friends, ...sizeRecommendation, ...sizeAdvisor };
